// ManageTeams.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from "../../config/default.json";
import { useTournament } from '../TournamentContext';

const base_url = config.base_url;

const ManageTeams = () => {
  const { tournamentID } = useTournament();
  const [teams, setTeams] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [editData, setEditData] = useState({});
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (tournamentID) {
      fetchTeams();
      fetchDivisions();
    }
  }, [tournamentID]);

  const fetchTeams = async () => {
    try {
      const res = await axios.get(`${base_url}/api/teams/${tournamentID}`);
      setTeams(res.data);
    } catch (err) {
      console.error("Error fetching teams", err);
    }
  };

  const fetchDivisions = async () => {
    try {
      const res = await axios.get(`${base_url}/api/divisions/${tournamentID}`);
      setDivisions(res.data);
    } catch (err) {
      console.error("Error fetching divisions", err);
    }
  };

  const handleSelect = (teamId) => {
    setSelectedTeams(prev =>
      prev.includes(teamId) ? prev.filter(id => id !== teamId) : [...prev, teamId]
    );
  };

  const handleFieldChange = (teamId, field, value) => {
    setEditData(prev => ({
      ...prev,
      [teamId]: {
        ...prev[teamId],
        [field]: value,
      }
    }));
  };

  const handleUpdateSelected = async () => {
    try {
      for (let teamId of selectedTeams) {
        if (editData[teamId]) {
          await axios.put(
            `${base_url}/api/${tournamentID}/teams/${teamId}`,
            editData[teamId],
            { headers: { Authorization: `Bearer ${token}` } }
          );
        }
      }
      fetchTeams();
      setEditData({});
       setSelectedTeams([]);
      alert("Selected teams updated successfully");
    } catch (err) {
      console.error("Error updating teams", err);
      alert("Error updating teams");
    }
  };

  const handleDeleteSelected = async () => {
    if (!window.confirm("Are you sure you want to delete the selected teams?")) return;

    try {
      for (let teamId of selectedTeams) {
        await axios.delete(`${base_url}/api/${tournamentID}/teams/${teamId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }
      fetchTeams();
      setSelectedTeams([]);
      alert("Selected teams deleted successfully");
    } catch (err) {
      console.error("Error deleting teams", err);
      alert("Error deleting teams." + ' ' + err.response?.data?.error || "");
    }
  };

  return (
    <div>
      <h2>Manage Teams</h2>
      <p>Select a team to edit or delete using checkbox.</p>
      <table border="1" cellPadding="5">
        <thead>
          <tr>
            <th>Select</th>
            <th>Team Name</th>
            <th>Captain</th>
            <th>State</th>
            <th>Division</th>
          </tr>
        </thead>
        <tbody>
          {teams.map(team => (
            <tr key={team._id}>
              <td>
                <input
                  type="checkbox"
                  checked={selectedTeams.includes(team._id)}
                  onChange={() => handleSelect(team._id)}
                />
              </td>
              <td>
                <input
                  type="text"
                  value={editData[team._id]?.name ?? team.name}
                  onChange={(e) => handleFieldChange(team._id, "name", e.target.value)}
                  disabled={!selectedTeams.includes(team._id)}
                />
              </td>
              <td>
                <input
                  type="text"
                  value={editData[team._id]?.captain ?? team.captain}
                  onChange={(e) => handleFieldChange(team._id, "captain", e.target.value)}
                  disabled={!selectedTeams.includes(team._id)}
                />
              </td>
              <td>
                <input
                  type="text"
                  value={editData[team._id]?.state ?? team.state}
                  onChange={(e) => handleFieldChange(team._id, "state", e.target.value)}
                  disabled={!selectedTeams.includes(team._id)}
                />
              </td>
              <td>
                <select
                  value={editData[team._id]?.division ?? team.division?._id ?? ""}
                  onChange={(e) => handleFieldChange(team._id, "division", e.target.value)}
                  disabled={!selectedTeams.includes(team._id)}
                >
                  <option value="">Select Division</option>
                  {divisions.map(div => (
                    <option key={div._id} value={div._id}>
                      {div.name}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div style={{ marginTop: "15px" }}>
        <button onClick={handleUpdateSelected} disabled={!selectedTeams.length}>
          Update Selected
        </button>
        &nbsp;
        <button onClick={handleDeleteSelected} disabled={!selectedTeams.length}>
          Delete Selected
        </button>
      </div>
    </div>
  );
};

export default ManageTeams;
